<template>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
            <v-card class="pa-3 mb-3 mx-auto text-left">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <div class="headline">Hello {{ info.username }}!</div>
                        </v-col>
                    </v-row>
                    <v-divider light></v-divider>
                    <v-row class="pt-5 pb-5">
                        <v-col cols="12" sm="12" md="12">
                            <div class="d-flex align-items-middle justify-space-between">
                                <div class="text">
                                    <div class="subtitle-2">Email Address</div>
                                    Your e-mail address is {{info.email}}
                                </div>
                                <v-btn @click="editEmail = !editEmail" small text>
                                    <span v-if="!editEmail">Change <v-icon>mdi-chevron-right</v-icon></span>
                                    <span v-if="editEmail"><v-icon>mdi-close</v-icon></span>
                                </v-btn>
                            </div>
                                <v-form
                                v-if="editEmail"
                                ref="form"
                                v-model="emailValid"
                                lazy-validation>
                                    <v-alert v-if="alertEmail" type="warning">
                                        {{alertEmail}}
                                    </v-alert>
                                    <v-row >
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            label="New Email" 
                                            v-model="email.email"
                                            :rules="emailRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            label="Confirm Email" 
                                            v-model="newEmailConfirm"
                                            :rules="emailRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn
                                            :disabled="!emailValid"
                                            color="success"
                                            class="mr-4"
                                            @click="saveEmail"
                                        >
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                    <v-divider light></v-divider>
                    <v-row class="pt-5 pb-5">
                        <v-col cols="12" sm="12" md="12">
                            <div class="d-flex align-items-middle justify-space-between">
                                <div class="text">
                                    <div class="subtitle-2">Password</div>
                                </div>
                                <v-btn @click="editPassword = !editPassword" small text>
                                    <span v-if="!editPassword">Change <v-icon>mdi-chevron-right</v-icon></span>
                                    <span v-if="editPassword"><v-icon>mdi-close</v-icon></span>
                                </v-btn>
                            </div>
                                <v-form
                                v-if="editPassword"
                                ref="form"
                                v-model="passwordValid"
                                lazy-validation>
                                    <v-alert v-if="alertPassword" type="warning">
                                        <ul>
                                            <li v-for="(alert,index) in alertPassword" v-bind:key="index" >{{alert}}</li>
                                        </ul>
                                    </v-alert>
                                    <v-row>
                                    <v-col cols="12" sm="4">
                                        <v-text-field
                                            label="Old Password" 
                                            v-model="password.old_password"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field
                                            label="New Password" 
                                            v-model="password.password"
                                            :rules="passwordRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field
                                            :disabled="!password.password"
                                            label="Confirm Password" 
                                            v-model="password.password_confirm"
                                            :rules="passwordRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn
                                            :disabled="!passwordValid"
                                            color="success"
                                            class="mr-4"
                                            @click="changePassword"
                                        >
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>    
                            </v-form>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>
<script>
import userForm from '@/components/form/user-form.vue';
	export default {
        components: {
            userForm
        },
        props: {
            id: Number   
        },
		data: () => ({
            loading: true,
            success: false,
            info: {
                username: '',
                email: '', 
            },
            input: {
                id: '',
            },
            password: {
                old_password: '',
                password: '',
                password_confirm:'',
            },
            email: {
                email: '',
            },
            newEmailConfirm: '',
            editPassword: false,
            editEmail: false,
            emailValid: true,
            passwordValid: true,
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            passwordRules: [
                v => !!v || 'Password is required',
            ],
            alertPassword: '',
            alertEmail: '',
		}),
		methods: {
            form() {
                if (this.id) {
                    this.getUser().then((res) => {
                        this.input.id = res.id;
                        this.info.username = res.username;
                        this.info.email = res.email;
                    });
                }
            },
			async getUser() {
                try {
                    this.loading = true
                    const res = await this.$api.user.get(this.id);
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    this.loading = false
                }
            },
            changeEmail(){
                this.sendEmail().then((res) => {
                    if (res.status == 200 || res.status == 201 ) {
                        this.$swal({
                            icon: 'success',
                            title: 'Saved',
                            reverseButtons: true,
                            confirmButtonText: 'Ok',
                        }).then((result) => {
                            if (result.value) {
                                this.form();
                            }
                        })
                    }
                })
            },
			async sendEmail() {
                try {
                    let res;
                    this.saving = true
                    if (this.input.id) {
                        res = await this.$api.accountProfile.changeEmail( this.email );
                    } else {
                        res = await this.$api.accountProfile.changeEmail( this.email );
                    }
                    return res;
                } catch (error) {
                    console.log(error.response);
                    this.alertPassword = error.response.data.password;
                    // handle error
                } finally {
                    this.saving = false
                }
            },
            changePassword(){
                this.sendPassword().then((res) => {
                    if (res.status == 200 || res.status == 201 ) {
                        this.$swal({
                            icon: 'success',
                            title: 'Saved',
                            reverseButtons: true,
                            confirmButtonText: 'Ok',
                        }).then((result) => {
                            if (result.value) {
                                this.form();
                            }
                        })
                    }
                })
            },
			async sendPassword() {
                try {
                    let res;
                    this.saving = true
                    if (this.input.id) {
                        res = await this.$api.accountProfile.changePassword( this.password );
                    } else {
                        res = await this.$api.accountProfile.changePassword( this.password );
                    }
                    return res;
                } catch (error) {
                    console.log(error.response);
                    this.alertPassword = error.response.data.password;
                    // handle error
                } finally {
                    this.saving = false
                }
            },
		},
		mounted () {
            this.form();
            this.loading = false;
		},
	}
</script>